import { ref } from 'vue';
import type {TokenEventDetail} from "@/models/token_event";
import type {YoutubeChannel} from "@/models/youtube_channel";

const _jwtToken = ref('');
const _country = ref('');
const _appId = ref('');
const _showPurplePlayer = ref(true);

const _channels = ref<YoutubeChannel[]>([]);
const _channelSearchQuery = ref('');
const _selectedTags = ref<string[]>([]);

function setDetails(details: TokenEventDetail) {
  _jwtToken.value = details.token;
  _country.value = details.country;
  _appId.value = details.app_id;
}

function setShowPurplePlayer(showPurplePlayer: boolean) {
  _showPurplePlayer.value = showPurplePlayer;
}

function setChannels(channels: YoutubeChannel[]) {
  _channels.value = channels;
}

function setChannelSearchQuery(query: string) {
  _channelSearchQuery.value = query;
}

function toggleSelectedTag(tag: string) {
  if (_selectedTags.value.includes(tag)) {
    _selectedTags.value = _selectedTags.value.filter(selectedTag => selectedTag !== tag);
    return;
  }
  _selectedTags.value = [..._selectedTags.value, tag];
}

export const store = {
  jwtToken: _jwtToken,
  country: _country,
  appId: _appId,
  showPurplePlayer: _showPurplePlayer,
  channels: _channels,
  channelSearchQuery: _channelSearchQuery,
  selectedTags: _selectedTags,
  setDetails,
  setShowPurplePlayer,
  setChannels,
  setChannelSearchQuery,
  toggleSelectedTag,
};
